import React from "react";
import { Card, Col, Row, Statistic } from "antd";

export default function MetricsCards({ metrics }) {
  const items = [
    { title: "Page Views", value: metrics.pageViews },
    { title: "Visitantes Únicos", value: metrics.uniqueVisitors },
    { title: "Sessões", value: metrics.sessions },
    { title: "Cliques WhatsApp", value: metrics.whatsappClicks },
    { title: "Tempo Médio (s)", value: metrics.avgTimeOnSite },
    { title: "CTR WhatsApp (%)", value: metrics.whatsappCtr },
  ];

  return (
    <Row gutter={[16, 16]}>
      {items.map((item) => (
        <Col xs={24} sm={12} md={8} lg={8} xl={4} key={item.title}>
          <Card>
            <Statistic title={item.title} value={item.value} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}